import { CompetitorComparison } from '@/components/CompetitorComparison';
import { useSEO } from '@/hooks/useSEO';

export default function AkeneoComparison() {
  useSEO({
    title: 'Ommni vs Akeneo - PIM Platform Comparison',
    description: 'Compare Ommni and Akeneo PIM platforms. Ommni offers inventory-ready PIM, workflow automation, faster implementation, and flexible pricing vs Akeneo enterprise licensing.',
    keywords: 'ommni vs akeneo, PIM comparison, akeneo alternative, product information management comparison',
    canonical: 'https://ommni.io/competitors/akeneo',
  });

  return (
    <CompetitorComparison
      title="Ommni vs Akeneo"
      competitorName="Akeneo"
      competitorUrl="https://www.akeneo.com/"
      whyOmmni={[
        "Inventory-Ready PIM: While Akeneo focuses primarily on product content enrichment, Ommni includes <a href='/features/inventory'>inventory</a> and pricing logic at the core, reducing reliance on third-party middleware.",
        "Workflow Automation: Ommni offers a no-code <a href='/features/ommni-flow'>workflow builder</a> for real-time product enrichment, validations, and approvals — ideal for lean, fast-paced retail teams.",
        "Modern Stack: Ommni is a cloud-native, API-first platform designed for direct-to-consumer and omnichannel retailers, whereas Akeneo often requires more technical configuration.",
        "Faster Time to Value: Get up and running faster with streamlined implementation, pre-built <a href='/integrations'>connectors</a>, and visual UI.",
        "Flexible Licensing: Ommni offers usage-based and modular <a href='/pricing'>pricing</a>, unlike Akeneo's more rigid enterprise licensing tiers."
      ]}
      comparisonTable={[
        { feature: "Inventory Management", ommni: true, competitor: false, link: "/features/inventory" },
        { feature: "Workflow Automation", ommni: true, competitor: false, link: "/features/ommni-flow" },
        { feature: "Implementation Speed", ommni: true, competitor: false },
        { feature: "Pricing Model", ommni: true, competitor: false, link: "/pricing" },
        { feature: "API-first & Cloud-native", ommni: true, competitor: true }
      ]}
    />
  );
}
